"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const maps_api_1 = require("maps-api");
const useKatastrMap_1 = require("../useKatastrMap");
function MapProvider({ children }) {
    return ((0, jsx_runtime_1.jsx)(useKatastrMap_1.KatastrProvider, { children: (0, jsx_runtime_1.jsx)(maps_api_1.PanoramaProvider, { children: children }) }));
}
exports.MapProvider = MapProvider;
